import common from './common/ordriket'

export default {
  name: 'Ordriket 5',
  slug: 'ordriket-5',
  level: 5,
  assets: {
    logo: '/themes/ordriket/ordriket-5-logo.svg',
    favicon: '/themes/ordriket/ordriket-fav.png',
  },
  login: {
    type: 'guardTeacherOnly',
  },
  uaid: 'UA-171789370-2',
  hotjarID: '1965286',
  addons: {
    overview: {
      extra: {
        title: 'Øv på',
        items: [
          {
            title: 'Språkøving',
            cover:
              'https://res.cloudinary.com/edtech/image/upload/v1628254362/language_tool_cover_bef4a24be5.png',
            url: 'https://sprakoving.app.fagbokforlaget.no',
          },
          {
            title: 'Skriveverktøy',
            cover:
              'https://res.cloudinary.com/edtech/image/upload/v1628254362/writing_tool_cover_7037624d32.png',
            url: 'https://skriveverktoy.app.fagbokforlaget.no/#/ordriket/',
          },
        ],
      },
    },
  },
  langs: [
    {
      code: 'nb',
      slug: 'ordriket-5',
      label: 'Bokmål',
    },
    {
      code: 'nn',
      slug: 'ordriket-5-nn',
      label: 'Nynorsk',
    },
  ],
  dbok: {
    nb: [
      {
        bookId: '60cc5eee5a95f60018d77f5e',
      },
      {
        bookId: '61bb4a585c01fe001203fcc7',
      },
      {
        bookId: '61f3facd69909d0012ae883c',
      },
    ],
    nn: [
      {
        bookId: '60ec44d35a95f60018d8056e',
      },
      {
        bookId: '61efff1663d68f00124208d0',
      },
      {
        bookId: '61f3facd69909d0012ae883c',
      },
    ],
  },
  ...common,
}
